(function () {
  var selectors = [
    '.hdt-drawer-cookie',
    '.shopify-pc__banner__wrapper',
    '.shopify-pc__banner__dialog',
    '.shopify-pc__banner'
  ];

  function hideCookieConsent() {
    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        node.setAttribute('aria-hidden', 'true');
        node.style.setProperty('display', 'none', 'important');
        node.style.setProperty('visibility', 'hidden', 'important');
        node.style.setProperty('pointer-events', 'none', 'important');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideCookieConsent, { once: true });
  } else {
    hideCookieConsent();
  }

  new MutationObserver(hideCookieConsent).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
